import React from 'react';
import { PropTypes } from 'prop-types';
import { observer } from 'mobx-react';
import config from 'config';
import _ from 'lodash';


import { Dropzone } from '../dropzone/dropzone.jsx';
import TextInput from '../forms/text-input';

@observer
export default class ScreenshotDropzone extends React.Component {

    static propTypes = {
        newAppMasterStore: PropTypes.object.isRequired,
        uploadImmediately: PropTypes.bool,
        disabled: PropTypes.bool,
        saveRef: PropTypes.func
      }

    static defaultProps = {
        uploadImmediately: true,
        disabled: false,
        saveRef: () => {}
    }

    constructor(props) {
        super(props);
        this.references = {};
    }

    handleUploadScreenshot = (event, deviceType) => {
        this.props.newAppMasterStore.newAppUploadStore.handleScreenshotUpload(event, deviceType, this.props.uploadImmediately);
    }

    handleReorderScreenshot = (deviceType, index, direction) => {
        this.props.newAppMasterStore.newAppUploadStore.reorderScreenshot(deviceType, index, direction);
    }

    handleRemoveScreenshot = (index, deviceType) => {
        if (!this.props.disabled) {
            this.props.newAppMasterStore.newAppUploadStore.removeScreenshot(index, deviceType);
        }
    }

    screenLimitReached = (deviceType) => {
        return this.props.newAppMasterStore.newAppUploadStore.screens[deviceType].length >= this.props.newAppMasterStore.newAppUploadStore.SCREEN_LIMIT;
    };



    getErrorMessage = (deviceType) => {
        if (this.props.newAppMasterStore.newAppUploadStore.invalidUploadAttempted[deviceType] === 1) {
            return this.props.newAppMasterStore.PNG_ERROR;
        } else if (this.props.newAppMasterStore.newAppUploadStore.invalidUploadAttempted[deviceType] === 2) {
            return this.props.newAppMasterStore.DIMENSIONS_ERROR;
        } else if (this.props.newAppMasterStore.masterStateProps.errorsAreDisplayed && this.props.newAppMasterStore.newAppDetailsStore[`${deviceType}ScreensAreMissing`]) {
            return this.props.newAppMasterStore.REQUIRED_ERROR;
        }
        return '';
    }

    renderLabelSection = (deviceType) => {
        let platform = this.props.newAppMasterStore.isAndroidApp ? 'android' : 'ios';
        let dimensions = config.screenDimensions[platform][deviceType];
        let suggestedPortrait = `${dimensions.short}x${dimensions.long}px`;
        let suggestedLandscape = `${dimensions.long}x${dimensions.short}px`;
        let minDimensions = `${dimensions.min}x${dimensions.min}px`;
        return (

            <label className="col-form-label" id={`${deviceType}ScreenshotUploadDescription`}>
                <span className="required">
                    {`${_.capitalize(deviceType)} screenshots`}
                </span>
                <span className="sr-only">This is a required field</span>
                <br />
                <span className="help-text as-block">
                    <div>PNG only</div>
                    <div>Max 5 images</div>
                    <div>
                        Suggested size:<br />
                        {suggestedPortrait}
                        (portrait)<br />
                        {suggestedLandscape}
                        (landscape)
                    </div>
                    <div>Min dimensions: {minDimensions}</div>
                </span>
            </label>
        )
    }

    renderScreenshotSection = (deviceType) => {
        let refName = deviceType === 'mobile' ? 'mobileScreenBrowserButton' : 'tabletScreenBrowserButton';
        const sectionIsVisible = this.props.newAppMasterStore.newAppData.device && this.props.newAppMasterStore.newAppData.device.toLowerCase().includes(deviceType);
        let fadeState = sectionIsVisible ? "fade-in" : "fade-out";
        return (
            <div className={`screenshot-fade ${fadeState}`}>
                <div className="col-3 form-group">
                    {this.renderLabelSection(deviceType)}
                </div>
                <div className="col-5 form-group">
                    <Dropzone
                        refName={refName}
                        saveRef={this.props.saveRef}
                        disabled={this.props.disabled || this.screenLimitReached(deviceType)}
                        onUpload={(event) => this.handleUploadScreenshot(event, deviceType)}
                        errorText={this.getErrorMessage(deviceType)}
                        hasError={Boolean(this.getErrorMessage(deviceType))} />
                </div>
                <div className="col-9 offset-3">
                    <div className="image-previews">
                        {this.renderAllImagePreviews({ deviceType })}
                    </div>
                </div>
            </div>
        )
    }

    renderAllImagePreviews = ({ deviceType }) => {
        let screens = this.props.newAppMasterStore.newAppUploadStore.screens[deviceType];
        if (!screens.length) { return null }
        return screens.map((screen, index) => {
            const textInputName = `${deviceType}Screenshot${index + 1}Description`;
            const canShiftLeft = index !== 0;
            const canShiftRight = index !== screens.length - 1;
            return (<div className={`preview ${deviceType}-aspect`} key={index}>
                <div className="image-wrapper">
                    <div className="image-container">
                        <img alt={`screenshot${index + 1}`} className={`${screen.isUploading
                            ? 'uploading'
                            : ''}`} src={screen.imageURL} />
                        {screen.isUploading && <div className="progress loading-indicator">
                            <div className="progress-bar progress-bar-striped active" role="progressbar" aria-valuenow={screen.progress} aria-valuemin="0" aria-valuemax="100" style={{
                                width: `${screen.progress}%`
                            }}>
                                <span className="sr-only">{screen.progress}% Complete</span>
                            </div>
                        </div>}
                        <div className="reorder">
                            {canShiftLeft && <button onClick={() => this.handleReorderScreenshot(deviceType, index, -1)} className="btn fn-secondary move move-left" disabled={this.props.disabled}>
                                <i className="icon-arrowLeft white"></i>
                            </button>}
                            {canShiftRight && <button onClick={() => this.handleReorderScreenshot(deviceType, index, 1)} className="btn fn-secondary move move-right" disabled={this.props.disabled}>
                                <i className="icon-arrowRight white"></i>
                            </button>}
                        </div>
                    </div>
                </div>
                <button className="btn fn-hi-contrast delete-button" onClick={() => this.handleRemoveScreenshot(index, deviceType)} disabled={this.props.disabled}>
                    <span className="sr-only">Remove screenshot {index + 1}</span>
                    <span className="icon-trash white"></span>
                </button>
                <TextInput
                    id={textInputName}
                    ref={(i) => {
                      this.references[textInputName] = i;
                      this.props.saveRef(textInputName, i);
                    }}
                    type="textarea"
                    required={true}
                    charLimit={80}
                    labelText="Image Description"
                    additionalSrText={`for screenshot ${index + 1}.`}
                    helperText="Max 80 characters."
                    errorMessage="Please enter a screenshot description."
                    value={screen.description}
                    updateValue={(newValue) => { this.props.newAppMasterStore.newAppUploadStore.changeScreenDescription(newValue, screen, deviceType) }}
                    disabled={this.props.disabled}
                    showErrorDirectiveFromMaster={this.props.newAppMasterStore.masterStateProps.errorsAreDisplayed} />
            </div>)
        });
    }

    render() {
        return (
            <div className="row screenshot-dropzone-section">
                {this.renderScreenshotSection('mobile')}
                {this.renderScreenshotSection('tablet')}
            </div>
        )
    }
}
